/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBrandLinktree = createReactComponent("brand-linktree", "IconBrandLinktree", [
  ["path", { d: "M9 3l-7 12h3v5h5v-5h-2l4 -7z", key: "svg-0" }],
  ["path", { d: "M15 3l7 12h-3v5h-5v-5h2l-4 -7z", key: "svg-1" }]
]);

export { IconBrandLinktree as default };
//# sourceMappingURL=IconBrandLinktree.js.map
